export default __webpack_public_path__ + "static/media/5.4Vid.1b1b7fa9.mp4";